(function() {
  // Initialize mega menu hover effects
  function initMegaMenuHover() {
    document.querySelectorAll(".header__inline-menu > .list-menu .mega-menu").forEach(function(element) {
      element.addEventListener("mouseenter", function() {
        var timer = element.dataset.timer || 0;

        // Remove hover classes from all other mega-menu items instantly
        document.querySelectorAll(".header__inline-menu > .list-menu .mega-menu").forEach(function(megaMenu) {
          if (megaMenu !== element) {
            clearTimeout(megaMenu.dataset.timer);
            megaMenu.classList.remove("hover-active", "hover-active-menu");
          }
        });

        clearTimeout(timer);
        element.classList.add("hover-active");

        timer = setTimeout(function() {
          element.classList.add("hover-active-menu");
        }, 300); // 500 is in mil sec eq to 0.5 sec.

        element.dataset.timer = timer;
      });

      element.addEventListener("mouseleave", function() {
        var timer = element.dataset.timer || 0;

        clearTimeout(timer);

        setTimeout(function() {
          element.classList.remove("hover-active", "hover-active-menu");
        }, 300);
      });
    });
  }

  // Initialize menu overlay effects
  function initMenuOverlay() {
    document.querySelectorAll(".header__inline-menu > .list-menu > li").forEach(function(menuItem) {
      menuItem.addEventListener("mouseenter", function() {
        document.body.classList.add("menu-overlay");
      });

      menuItem.addEventListener("mouseleave", function() {
        document.body.classList.remove("menu-overlay");
      });
    });
  }

  // Initialize contact form popup
  function initContactFormPopup() {
    // Check if URL contains contact_posted parameter
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('contact_posted')) {
      var contactFormSection = document.querySelector('.shopify-section-group-footer-group[id*="contact_form"]');
      if (contactFormSection) {
        contactFormSection.classList.add("show-contact-form");
      }
    }

    // Check if URL hash is #contact-popup
    if (window.location.hash === '#contact-popup') {
      var contactFormSection = document.querySelector('.shopify-section-group-footer-group[id*="contact_form"]');
      if (contactFormSection) {
        contactFormSection.classList.add("show-contact-form");
      }
    }

    // Listen for hash changes
    window.addEventListener('hashchange', function() {
      if (window.location.hash === '#contact-popup') {
        var contactFormSection = document.querySelector('.shopify-section-group-footer-group[id*="contact_form"]');
        if (contactFormSection) {
          contactFormSection.classList.add("show-contact-form");
        }
      }
    });

    document.querySelectorAll(".footer-contact-popup").forEach(function(element) {
      element.addEventListener("click", function() {
        document.querySelector('.shopify-section-group-footer-group[id*="contact_form"]').classList.add("show-contact-form");
      });
    });

    // Handle links with href="#contact-popup"
    document.querySelectorAll('a[href="#contact-popup"]').forEach(function(element) {
      element.addEventListener("click", function(event) {
        event.preventDefault();
        var contactFormSection = document.querySelector('.shopify-section-group-footer-group[id*="contact_form"]');
        if (contactFormSection) {
          contactFormSection.classList.add("show-contact-form");
        }
      });
    });
  }

  // Initialize contact form close on outside click
  function initContactFormClose() {
    // Close button click handler
    document.querySelectorAll(".close-contact-popup").forEach(function(element) {
      element.addEventListener("click", function() {
        var contactFormSection = document.querySelector('.shopify-section-group-footer-group[id*="contact_form"]');
        if (contactFormSection) {
          contactFormSection.classList.remove("show-contact-form");
        }
      });
    });

    // Outside click handler
    document.addEventListener("click", function(event) {
      var contactFormSection = document.querySelector('.shopify-section-group-footer-group[id*="contact_form"]');
      var contactFormFooter = document.querySelector('.contact-form-footer');

      if (contactFormSection && contactFormSection.classList.contains("show-contact-form")) {
        if (contactFormFooter && !contactFormFooter.contains(event.target) && !event.target.closest(".footer-contact-popup") && !event.target.closest('a[href="#contact-popup"]')) {
          contactFormSection.classList.remove("show-contact-form");
        }
      }
    });
  }

  // Initialize estimate delivery popup (PDP)
  function initEstimateDeliveryPopup() {
    // Open popup
    document.querySelectorAll(".estimate-delivery-btn").forEach(function(btn) {
      btn.addEventListener("click", function() {
        var popupId = btn.getAttribute("aria-controls");
        if (!popupId) return;
        var popup = document.getElementById(popupId);
        if (!popup) return;
        popup.classList.add("is-open");
        popup.setAttribute("aria-hidden", "false");
      });
    });

    // Close popup (close button)
    document.querySelectorAll(".estimate-delivery-popup__close").forEach(function(closeBtn) {
      closeBtn.addEventListener("click", function() {
        var popup = closeBtn.closest(".estimate-delivery-popup");
        if (!popup) return;
        popup.classList.remove("is-open");
        popup.setAttribute("aria-hidden", "true");
      });
    });

    // Close popup on outside click
    document.addEventListener("click", function(event) {
      var openPopups = document.querySelectorAll(".estimate-delivery-popup.is-open");
      if (!openPopups.length) return;

      openPopups.forEach(function(popup) {
        var content = popup.querySelector(".estimate-delivery-popup__content");
        if (!content) return;
        if (content.contains(event.target)) return;
        if (event.target.closest(".estimate-delivery-btn")) return;

        popup.classList.remove("is-open");
        popup.setAttribute("aria-hidden", "true");
      });
    });
  }

  // Initialize header search toggle
  function initHeaderSearchToggle() {
    document.querySelectorAll(".header-search-toggle").forEach(function(element) {
      element.addEventListener("click", function() {
        document.body.classList.toggle("search-dropdown-open");
      });
    });
  }

  // Initialize header fixed scroll behavior
  function initHeaderFixed() {
    var headerHeading = document.querySelector('.header__heading');
    var headerOtherLinks = document.querySelector('.header__other-links');
    var headerTopContent = document.querySelector('.header-top-content');
    var headerLogoSticky = document.querySelector('.header__logo_sticky');
    var headerOtherItems = document.querySelector('.header__other__items');
    
    // Store original positions
    var originalHeadingParent = null;
    var originalOtherLinksParent = null;
    var isFixed = false;

    function updateHeaderState() {
      var scrollTop = window.scrollY || window.pageYOffset;
      var isDesktop = window.innerWidth >= 1025;
      var shouldBeFixed = scrollTop >= 150;
      
      // Store original positions if not already stored
      if (!originalHeadingParent && headerHeading) {
        originalHeadingParent = headerHeading.parentNode;
      }
      
      if (!originalOtherLinksParent && headerOtherLinks) {
        originalOtherLinksParent = headerOtherLinks.parentNode;
      }
      
      if (shouldBeFixed) {
        if (!isFixed) {
          // Add fixed class
          document.body.classList.add('header-fixed');
          isFixed = true;
        }
        
        // Move elements only on desktop
        if (isDesktop) {
          // Move header__heading to header__logo_sticky if not already there
          if (headerLogoSticky && headerHeading && headerHeading.parentNode !== headerLogoSticky) {
            headerLogoSticky.appendChild(headerHeading);
          }
          
          // Move header__other-links element to header__other__items if not already there
          if (headerOtherItems && headerOtherLinks && headerOtherLinks.parentNode !== headerOtherItems) {
            headerOtherItems.appendChild(headerOtherLinks);
          }
        } else {
          // On mobile, restore elements to original positions if they were moved
          if (headerHeading && headerHeading.parentNode !== originalHeadingParent && originalHeadingParent && headerTopContent) {
            headerTopContent.insertBefore(headerHeading, headerTopContent.firstChild);
          }
          
          if (headerOtherLinks && headerOtherLinks.parentNode !== originalOtherLinksParent && originalOtherLinksParent && headerTopContent) {
            headerTopContent.appendChild(headerOtherLinks);
          }
        }
      } else {
        if (isFixed) {
          // Remove fixed class
          document.body.classList.remove('header-fixed');
          isFixed = false;
        }
        
        // Restore elements to original positions (only on desktop, or if they were moved)
        if (isDesktop) {
          // Move header__heading back to header-top-content (first position)
          if (originalHeadingParent && headerHeading && headerTopContent && headerHeading.parentNode !== originalHeadingParent) {
            headerTopContent.insertBefore(headerHeading, headerTopContent.firstChild);
          }
          
          // Move header__other-links back to header-top-content (last position)
          if (originalOtherLinksParent && headerOtherLinks && headerTopContent && headerOtherLinks.parentNode !== originalOtherLinksParent) {
            headerTopContent.appendChild(headerOtherLinks);
          }
        }
      }
    }

    // Handle scroll event
    window.addEventListener('scroll', updateHeaderState);
    
    // Handle resize event
    window.addEventListener('resize', updateHeaderState);
    
    // Check initial scroll position
    updateHeaderState();
  }

  // Initialize all functions
  function init() {
    initMegaMenuHover();
    initMenuOverlay();
    initContactFormPopup();
    initContactFormClose();
    initEstimateDeliveryPopup();
    initHeaderSearchToggle();
    initHeaderFixed();
  }

  // Run initialization when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
